import React from "react";
import { Row, Col } from "reactstrap";
import './transactionResponse.css';
import { useTranslation } from "react-i18next";

const TokensTransactionSuccess = () => {
    const { t } = useTranslation();

    return (
        <div className='bl-back-image'>
            <Row>
                <Col xl="12" lg="12" md="12" sm="12" xm="12" style={{marginTop: '10%'}}>
                    <div>
                        <h1 className="text-center text-success text-congrats">
                            {t("tokens.transaction.success.title")}
                        </h1>

                        <div className="text-center text-white pl-2 pr-2" style={{fontSize: '20px', marginTop: '40px'}}>
                            <p>
                                {t("tokens.transaction.success.description")}<br/> 
                            </p>
                        </div>

                        <div className="text-center mt-5">
                            <a href="/dashboard" className="btn btn-ml btn-lg mr-3">
                                <span className="fas fa-user pr-2"></span>
                                {t("tokens.transaction.button.returnToDashboard")} 
                            </a>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default TokensTransactionSuccess;